import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { IoIosInformationCircleOutline } from "react-icons/io";
import Tooltip from "@mui/material/Tooltip";
import countryList from 'react-select-country-list';
import {
  StyledInput,
  StyledInputContainer,
  StyledInputGroup,
  StyledLabel,
  StyledSelect,
  StyledSelectContainer,
  StyledSelectGroup,
} from "../../StyledCss/styledInputs";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";
import { ErrorText } from "../../StyledCss/styledComponents";
import MultiInput from "../MultiInput";
const AddClientPopup = ({
  onSubmitData,
  closeBtn,
  defaultValues,
  isEditMode,
  isLoading,
  errorMessage
}) => {
  const predefinedModes = ["Bank Transfer", "Pay Pal", "Wire", "Other"];
  const isOtherMode = defaultValues?.paymentTransferMode && !predefinedModes.includes(defaultValues.paymentTransferMode);

  const flattenedDefaults = defaultValues ? {
    ...defaultValues,
    paymentTransferMode: isOtherMode ? "Other" : defaultValues.paymentTransferMode,
    otherPaymentMode: isOtherMode ? defaultValues.paymentTransferMode : "",
    billingAddress: defaultValues.billingInfo?.billingAddress || "",
    billingState: defaultValues.billingInfo?.billingState || "",
    billingCountry: defaultValues.billingInfo?.billingCountry || "",
    billingEmail: defaultValues.billingInfo?.billingEmail || "",
    clientEmail: defaultValues.clientEmail || "",
    gstNumber: defaultValues.gstNumber || "",
  } : {};

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: flattenedDefaults,
  });
  const [isSameAddress, setIsSameAddress] = useState(() => {
    if (!defaultValues) return false;
    const billingInfo = defaultValues.billingInfo || {};
    return (
      defaultValues.clientEmail === billingInfo.billingEmail &&
      defaultValues.address === billingInfo.billingAddress &&
      defaultValues.state === billingInfo.billingState &&
      defaultValues.country === billingInfo.billingCountry
    );
  });
  const [ccEmails, setCcEmails] = useState(defaultValues?.billingInfo?.ccEmails || []);
  const [bccEmails, setBccEmails] = useState(defaultValues?.billingInfo?.bccEmails || []);  
  const countries = countryList().getData();
  const clientEmail = watch("clientEmail");
  const clientAddress = watch("address");
  const clientState = watch("state");
  const clientCountry = watch("country");
  const billingCountry = watch("billingCountry");
  const paymentTransferMode = watch("paymentTransferMode");


  useEffect(() => {
    if (isSameAddress) {
      setValue("billingEmail", clientEmail || "");
    }
  }, [isSameAddress, clientEmail, setValue]);

  useEffect(() => {
    if (isSameAddress) {
      setValue("billingAddress", clientAddress || "");
    }
  }, [isSameAddress, clientAddress, setValue]);

  useEffect(() => {
    if (isSameAddress) {
      setValue("billingState", clientState || "");
    }
  }, [isSameAddress, clientState, setValue]);

  useEffect(() => {
    if (isSameAddress) {
      setValue("billingCountry", clientCountry || "");
    }
  }, [isSameAddress, clientCountry, setValue]);

  useEffect(() => {
    if (billingCountry?.toLowerCase() !== "india") {
      setValue("gstNumber", "");
    }
  }, [billingCountry]); // eslint-disable-line react-hooks/exhaustive-deps


  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsSameAddress(checked);
    
    if (checked) {
      setValue("billingEmail", clientEmail);
      setValue("billingAddress", clientAddress);
      setValue("billingState", clientState);
      setValue("billingCountry", clientCountry);
    } else {
      setValue("billingAddress", "");
      setValue("billingState", "");
      setValue("billingCountry", "");
      setValue("billingEmail", "");
    }
  };

  const onSubmit = (data) => {
    const {
      name,
      paymentTransferMode,
      address,
      state,
      country,
      gstNumber,
      clientEmail,
      billingAddress,
      billingState,
      billingCountry,
      billingEmail,
      id
    } = data;

    const submitData = {
      name,
      address,
      state,
      paymentTransferMode: paymentTransferMode === "Other" ? data.otherPaymentMode : paymentTransferMode,
      country,
      gstNumber,
      clientEmail,
      billing_info:{
              billingAddress,
              billingState,
              billingCountry,
              billingEmail,
              ccEmails: ccEmails,
              bccEmails: bccEmails

      },
      id
    };

    onSubmitData(submitData);
  };

  return (
    <div className="popup-content">
      <div className="add-employee-form">
          {/* Client Name */}
          <h5 style={{ marginBottom: "15px" }}>Client Details</h5>
          <div className="add-employee-form-container">
            <StyledInputGroup>
            <StyledInputContainer>
              <StyledInput
                placeholder="Enter Client Name"
                style={{
                  ...(errors.name && {
                    borderLeft: "10px solid red",
                  }),
                }}
                type="text"
                {...register("name", {
                  required: true,
                  setValueAs: (value) => value?.trim(),
                })}
              />
              <StyledLabel className="user-label">Name*</StyledLabel>
            </StyledInputContainer>
          </StyledInputGroup>
             {/* Client Email */}
          <StyledInputGroup>
            <StyledInputContainer>
              <StyledInput
                placeholder="Enter Client Email"
                style={{
                  ...(errors.clientEmail && {
                    borderLeft: "10px solid red",
                  }),
                }}
                type="email"
                {...register("clientEmail", {
                  required: true,
                  pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  setValueAs: (value) => value?.trim(),

                })}
              />
              <StyledLabel hasValue={!!clientEmail} className="user-label">Client Email*</StyledLabel>
            </StyledInputContainer>
          </StyledInputGroup>
          </div>
           <h5 style={{ marginBottom: "20px", marginTop: "18px" }}>
          Payment Details
        </h5>
        <div className="add-employee-form-container">
          <StyledSelectGroup>
            <StyledSelectContainer>
              <StyledSelect
                style={
                  errors.paymentTransferMode && { borderLeft: "10px solid red" }
                }
                {...register("paymentTransferMode", { required: true })}
              >
                <option value="">---Select Payment Transfer Mode---</option>
                <option value="Bank Transfer">Bank Transfer</option>
                <option value="Pay Pal">Pay Pal</option>
                <option value="Wire">Wire</option>
                <option value="Other">Other</option>
              </StyledSelect>
              <StyledLabel className="user-label">Transfer Mode*</StyledLabel>
            </StyledSelectContainer>
          </StyledSelectGroup>
          {paymentTransferMode === "Other" && (
            <StyledInputGroup>
              <StyledInputContainer>
                <StyledInput
                  placeholder="Enter Payment Transfer Mode"
                  type="text"
                  {...register("otherPaymentMode", { required: true })}
                  style={{
                    ...(errors.otherPaymentMode && {
                      borderLeft: "10px solid red",
                    }),
                  }}
                />
                <StyledLabel className="user-label">Other Payment Mode*</StyledLabel>
              </StyledInputContainer>
            </StyledInputGroup>
          )}
        </div>
          <h5 style={{ marginBottom: "20px", marginTop: "18px" }}>
          Client Address
        </h5>


          <div className="add-employee-form-container">
            {/* Client Address */}
          <StyledInputGroup>
            <StyledInputContainer>
              <StyledInput
                placeholder="Enter Client Street Address"
                style={{
                  ...(errors.address && {
                    borderLeft: "10px solid red",
                  }),
                }}
                type="text"
                {...register("address", {
                  required: true,
                  setValueAs: (value) => value?.trim(),
                })}
              />
              <StyledLabel className="user-label">Street Address*</StyledLabel>
            </StyledInputContainer>
          </StyledInputGroup>

          {/* Client State */}
          <StyledInputGroup>
            <StyledInputContainer>
              <StyledInput
                placeholder="Enter Client State"
                style={{
                  ...(errors.state && {
                    borderLeft: "10px solid red",
                  }),
                }}
                type="text"
                {...register("state", {
                  required: true,
                  pattern: /^(?!\s)[A-Za-z\s]{3,60}$/,
                  setValueAs: (value) => value?.trim(),
                })}
              />
              <StyledLabel className="user-label">State*</StyledLabel>
            </StyledInputContainer>
          </StyledInputGroup>

          <StyledSelectGroup>
            <StyledSelectContainer>
              <StyledSelect
                style={{
                  ...(errors.country && { borderLeft: "10px solid red" }),
                }}
                {...register("country", { required: true })}
              >
                <option value="" style={{ padding: "2px 8px", fontSize: "14px" }}>---Select Country---</option>
                {countries.map((country) => (
                  <option key={country.label} value={country.label} style={{ padding: "2px 8px", fontSize: "14px" }}>
                    {country.label}
                  </option>
                ))}
              </StyledSelect>
              <StyledLabel className="user-label">Country*</StyledLabel>
            </StyledSelectContainer>
          </StyledSelectGroup>
          </div>

       

          

          {/* Billing Email */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", marginTop: "18px" }}>
            <h5 style={{ margin: 0 }}>Billing Address</h5>
            <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={isSameAddress}
                onChange={handleCheckboxChange}
                style={{ cursor: "pointer" }}
              />
              <span>Billing details is same as client details</span>
            </label>
          </div>
          <div className="add-employee-form-container">
            {/* Billing Address */}
          <StyledInputGroup>
            <StyledInputContainer>
              <StyledInput
                placeholder="Enter Billing Street Address"
                disabled={isSameAddress}
                style={{
                  ...(errors.billingAddress && {
                    borderLeft: "10px solid red",
                  })
                }}
                type="text"
                {...register("billingAddress", {
                  required: true,
                })}
              />
              <StyledLabel hasValue={isSameAddress} className="user-label">Street Address*</StyledLabel>
            </StyledInputContainer>
          </StyledInputGroup>

          {/* Billing State */}
          <StyledInputGroup>
            <StyledInputContainer>
              <StyledInput
                placeholder="Enter Billing State"
                disabled={isSameAddress}
                style={{
                  ...(errors.billingState && {
                    borderLeft: "10px solid red",
                  })
                }}
                type="text"
                {...register("billingState", {
                  required: true,
                  pattern: /^(?!\s)[A-Za-z\s]{3,60}$/,
                })}
              />
              <StyledLabel hasValue={isSameAddress} className="user-label">State*</StyledLabel>
            </StyledInputContainer>
          </StyledInputGroup>
        <StyledSelectGroup>
            <StyledSelectContainer>
              <StyledSelect
                disabled={isSameAddress}
                style={{
                  ...(errors.billingCountry && { borderLeft: "10px solid red" }),
                }}
                {...register("billingCountry", { required: true })}
              >
                <option value="" style={{ padding: "2px 8px", fontSize: "14px" }}>---Select Country---</option>
                {countries.map((country) => (
                  <option key={country.label} value={country.label} style={{ padding: "2px 8px", fontSize: "14px" }}>
                    {country.label}
                  </option>
                ))}
              </StyledSelect>
              <StyledLabel hasValue={isSameAddress} className="user-label">Country*</StyledLabel>
            </StyledSelectContainer>
          </StyledSelectGroup>
          {/* GST Number - Moved to end to prevent UI cramping */}
          {billingCountry?.toLowerCase() === "india" && (
            <StyledInputGroup>
              <StyledInputContainer>
                <StyledInput
                  placeholder="Enter GST Number"
                  style={{
                    ...(errors.gstNumber && {
                      borderLeft: "10px solid red",
                    }),
                  }}
                  type="text"
                  {...register("gstNumber", {
                    required: true,
                    pattern:
                      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                    setValueAs: (value) => value?.trim(),
                  })}
                />
                <StyledLabel hasValue={true} className="user-label">
                  GST Number*
                </StyledLabel>
                <Tooltip title="GST Number (Format: 00AAAAA0000A0Z0) 13th & 15th can be letters or numbers" arrow>
                                      <span
                                        style={{
                                          position: "absolute",
                                          right: "10px",
                                          top: "5px",
                                        }}
                                      >
                                        <IoIosInformationCircleOutline className="info-icon" />
                                      </span>
                                    </Tooltip>
              </StyledInputContainer>
            </StyledInputGroup>
          )}

          <StyledInputGroup>
            <StyledInputContainer>
              <StyledInput
                placeholder="Enter Billing Email"
                disabled={isSameAddress}
                style={{
                  ...(errors.billingEmail && {
                    borderLeft: "10px solid red",
                  })
                }}
                type="email"
                {...register("billingEmail", {
                  required: true,
                  pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  setValueAs: (value) => value?.trim(),
                })}
              />
              <StyledLabel hasValue={isSameAddress} className="user-label">Billing Email*</StyledLabel>
            </StyledInputContainer>
          </StyledInputGroup>

          <MultiInput
            placeholder="Enter CC Email"
            email
            label="CC Email"
            existingItems={[]}
            newItems={ccEmails}
            onAdd={(email) => setCcEmails([...ccEmails, email])}
            onRemove={(email) => setCcEmails(ccEmails.filter(e => e !== email))}
          />

          <MultiInput
            placeholder="Enter BCC Email"
            email
            label="BCC Email"
            existingItems={[]}
            newItems={bccEmails}
            onAdd={(email) => setBccEmails([...bccEmails, email])}
            onRemove={(email) => setBccEmails(bccEmails.filter(e => e !== email))}
          />


          
          </div>
        
      </div>
        {errorMessage && (
                <ErrorText className="mt-3">*{errorMessage}</ErrorText>
              )}

      {/* Buttons */}
      <div className="d-flex gap-2 justify-content-end mt-4">
        <SecondaryButton onClick={closeBtn}>Cancel</SecondaryButton>
        <PrimaryButton onClick={handleSubmit(onSubmit)} disabled={isLoading}>
          {isLoading
            ? isEditMode
              ? "Updating..."
              : "Adding..."
            : isEditMode
            ? "Update"
            : "Add"}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default AddClientPopup;